import React, { useState, useEffect } from 'react';
import LoginDeliveryView from './LoginDeliveryView';
import RegistroDeliveryView from './RegistroDeliveryView';
// ❌ Eliminamos el Navbar genérico
import './IntroDeliveryPanel.css'; 

function IntroDeliveryPanel({ defaultVista = 'inicio' }) {
  const [vista, setVista] = useState(defaultVista);

  useEffect(() => {
    setVista(defaultVista);
  }, [defaultVista]);

  const renderVista = () => {
    switch (vista) {
      case 'login':
        return (
          <>
            <LoginDeliveryView />
            {/* <p style={{ color: '#fff', marginTop: '15px', textAlign: 'center' }}>
              ¿Eres nuevo repartidor? <span style={{ color: '#ff0000', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => setVista('registro')}>Regístrate aquí</span>
            </p> */}
          </>
        );
      case 'registro':
        return (
          <>
            <RegistroDeliveryView />
            <p style={{ color: '#fff', marginTop: '15px', textAlign: 'center' }}>
              ¿Ya tienes cuenta? <span style={{ color: '#ff0000', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => setVista('login')}>Inicia Sesión</span>
            </p>
          </>
        );
      default:
        return (
          <div style={{
            backgroundColor: '#111',
            padding: '40px',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)',
            width: '100%',
            maxWidth: '400px',
            margin: '40px auto',
            textAlign: 'center'
          }}>
            <h1 style={{ color: '#ff0000', marginBottom: '30px' }}>Bienvenido a Clavelina Delivery</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <button className="intro-button" onClick={() => setVista('login')}>Ingresar</button>
              <button className="intro-button" onClick={() => setVista('registro')}>Registrarse</button>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="intro-fondo">
      {/* No incluimos Navbar aquí. 
         Cuando el repartidor haga login, App.js detectará el rol 'delivery' 
         y mostrará el DeliveryNavbar automáticamente en la ruta /delivery 
      */}
      <div className="intro-content">
        {renderVista()}
      </div>
    </div>
  );
}

export default IntroDeliveryPanel;